import i18n from '@/locales/i18n';
import { getOptionMap } from '@/libs/tools';
import isBaiyuHardwareEnabled from '@libs/isBaiyuHardwareEnabled';
export const replyLangOptions = [
  {
    value: 1,
    label: i18n.global.t('libs.enums.4ca56b8f2d68230dbb1cb8464f3a46ba')
  },
  {
    value: 2,
    label: i18n.global.t('libs.enums.331632659ad74586ac7cd0086d2ac88c')
  }
];
export const replyLangOptionsMap = getOptionMap(replyLangOptions);
export const sessionTimeOptions = [
  {
    value: 1,
    label: i18n.global.t('libs.enums.4cb944d63ff4dd89cc322d689194f622')
  },
  {
    value: 2,
    label: i18n.global.t('libs.enums.19cec7ae5d7d294578cdd7add1f92ea2')
  },
  {
    value: 3,
    label: i18n.global.t('libs.enums.2468c53351e85d880110c94d75ea4059')
  },
  {
    value: 4,
    label: i18n.global.t('libs.enums.e7855f621a8ad756619cbec2e2cd2af3')
  }
];
export const chatModel = [
  {
    value: 1,
    label: 'GPT-35-turbo'
  }
];
export const feedBackMap = {
  0: {
    label: i18n.global.t('libs.enums.69b36f5f8551992abe4407b01c7896fa'),
    color: '#fff'
  },
  1: {
    label: i18n.global.t('libs.enums.0427582ddb3d6cc3d3923939e5d43e0e'),
    color: '#fff',
    icon: 'like'
  },
  2: {
    label: i18n.global.t('libs.enums.702c024a70c5aeed239b0d96f1e0e8a6'),
    color: 'var(--theme-color)',
    icon: 'notLike'
  },
  3: {
    label: i18n.global.t('libs.enums.b9387d30fec623275cadb996e2d10c46'),
    color: '#fff',
    icon: ''
  },
  4: {
    label: i18n.global.t('libs.enums.7755d4eabf28accd41df896afddd5155'),
    color: 'var(--theme-color)'
  }
};
export const visitHomeOption = [
  {
    label: i18n.global.t('libs.enums.66299b8c58c4bee03378e42827cb4bd7'),
    value: 'home_manager'
  },
  {
    label: i18n.global.t('libs.enums.323baf534fbef40092d50795f82cac1f'),
    value: 'home_member'
  }
];
export const visitBotOption = [
  {
    label: i18n.global.t('libs.enums.323baf534fbef40092d50795f82cac1f'),
    value: 'home_member'
  }
];
export const roleOptions = [
  {
    label: i18n.global.t('libs.enums.3e2b7ae3d70461b203313e69c8b39b05'),
    value: 'home_manager'
  },
  {
    label: i18n.global.t('libs.enums.3408f5b5a515a2f2100a6ba139fc785c'),
    value: 'home_member'
  }
];
export const paginationConfig = {
  CURRENT_PAGE_PARAMETER: 'page',
  PAGE_SIZE_PARAMETER: 'pagesize',
  LIST_DATA_PARAMETER: 'list',
  LIST_TOTAL_PARAMETER: 'total'
};
export const dataSetOptions = [
  {
    label: i18n.global.t('libs.enums.a6833d781d81d661454ef38f04accd48'),
    value: 1
  },
  {
    label: i18n.global.t('libs.enums.ed3b6c8b53948dbee94f0a55148ddf25'),
    value: 2
  }
];
export const folderTypeOptions = [
  {
    label: i18n.global.t('libs.enums.9ae576354cab4b01942c11b8a303d40a'),
    value: 1
  },
  {
    label: i18n.global.t('libs.enums.f191181627d5121f8665a35d746e471a'),
    value: 2
  },
  {
    label: i18n.global.t('libs.enums.2d68044759b50ca57c8244e6f4677841'),
    value: 3
  },
  {
    label: i18n.global.t('libs.enums.f1a22a7c54e7ede71d01f6a6708024b8'),
    value: 4
  }
];
export const uploadStatusOptions = [
  {
    label: i18n.global.t('libs.enums.a08989cee59d73b80c2ce921bc328670'),
    value: 0
  },
  {
    label: i18n.global.t('libs.enums.afc9393dba7be4f85a96570d07acc0e1'),
    value: 1
  },
  {
    label: i18n.global.t('libs.enums.f3c209eb5b2c43a7f49bcc0bf2602efd'),
    value: 2
  },
  {
    label: i18n.global.t('libs.enums.0fc3afc42d6c625e9872b191d6e3920e'),
    value: 3
  },
  {
    label: i18n.global.t('libs.enums.c8a39f977494a3290002e41262d88a52'),
    value: 4
  }
];
export const dataSourceOptions = [
  {
    label: i18n.global.t('libs.enums.ea4a8667b6d9117c9fee0c1105d30a88'),
    value: 1
  },
  {
    label: i18n.global.t('libs.enums.874c32d8dde974e406755d242cd73015'),
    value: 2
  },
  {
    label: i18n.global.t('libs.enums.9f570f80e9dad8d2492bb81c06bbba51'),
    value: 3
  },
  {
    label: i18n.global.t('libs.enums.e6fd4855c076dc8a09d7d34e8bb81661'),
    value: 4
  },
  {
    label: i18n.global.t('libs.enums.a0deffb26a2950d369909221bb4dd8f3'),
    value: 5
  },
  {
    label: i18n.global.t('libs.enums.eaeb3495f3ffebcd201668a1c1184b0e'),
    value: 6
  },
  {
    label: i18n.global.t('libs.enums.9fc04cdb0d702cb7af8dba725d668d10'),
    value: 7
  }
];
export const yesOrNoOptions = [
  {
    label: i18n.global.t('libs.enums.8ae3582fc964e49560f1b01a6c050625'),
    value: 1
  },
  {
    label: i18n.global.t('libs.enums.80960245aebcf48fedcd5d861c94f14e'),
    value: 0
  }
];
const addTitleIfNeeded = options => {
  const showTitle = !IS_DOMESTIC || i18n.global.locale.value !== 'zh_CN';
  return options.map(option => {
    if (showTitle && option.label) {
      return {
        ...option,
        title: option.label
      };
    }
    return option;
  });
};
const messageSourceOptionsBase = [
  {
    label: i18n.global.t('libs.enums.be9f591c26f8ecbc649ee34cb27ca35b'),
    value: 'ding'
  },
  {
    label: 'Agent Studio',
    value: 'web'
  },
  {
    label: i18n.global.t('libs.enums.34ec743e04dc7bea3606df9259947bdd'),
    value: 'web_share'
  },
  {
    label: 'Open Api',
    value: 'other'
  },
  {
    label: 'Agent Store',
    value: 'store-robot-ws'
  },
  {
    label: 'Lark',
    value: 'lark'
  },
  {
    label: 'WhatsApp',
    value: 'whatsapp'
  },
  {
    label: 'Email',
    value: 'email'
  },
  {
    label: 'Zendesk',
    value: 'zendesk'
  },
  {
    label: 'Debug Preview',
    value: 'web_preview'
  },
  {
    label: 'WeCom',
    value: 'wecom'
  },
  {
    label: 'Facebook',
    value: 'facebook'
  },
  {
    label: 'Instagram',
    value: 'instagram'
  },
  {
    label: i18n.global.t('libs.enums.bc960d01c6813c567939c4bd11534fbf'),
    value: 'workshop'
  },
  {
    label: i18n.global.t('libs.enums.0205f2a21a01201b7e9d3f0f81b3704a'),
    value: 'eval'
  },
  {
    label: i18n.global.t('libs.enums.af85f27b317354a64976bc8c87837ed0'),
    value: 'agent_optimize'
  }
];
export const multiAgentMessageSourceOptionsBase = [
  {
    label: 'WhatsApp',
    value: 'whatsapp'
  },
  {
    label: 'Telegram',
    value: 'telegram'
  }
];
export const getMessageSourceOptions = () =>
  addTitleIfNeeded(messageSourceOptionsBase);
export const messageSourceOptions = messageSourceOptionsBase;
export const voiceAgentMessageSourceOptionsBase = [
  {
    label: i18n.global.t('libs.enums.05bf4cd4c3acbd3e85b13726886a0cce'),
    value: 'web_preview'
  },
  {
    label: isBaiyuHardwareEnabled()
      ? ''
      : i18n.global.t('libs.enums.9b1f60900bf369d24f9679edff49ea03'),
    value: 'web'
  },
  {
    label: i18n.global.t('libs.enums.34ec743e04dc7bea3606df9259947bdd'),
    value: 'web_share'
  },
  {
    label: i18n.global.t('libs.enums.b6c08876e702b622e9a6b0f581d9bb82'),
    value: 'other'
  }
];
export const operateTypeOptions = [
  {
    label: i18n.global.t('libs.enums.52f9f40346249f7af8dccd42b22fe1ce'),
    value: '='
  },
  {
    label: i18n.global.t('libs.enums.56c0eb597fdca2116900431cee8f0684'),
    value: '≠'
  },
  {
    label: i18n.global.t('libs.enums.1b2d9fb4df913094e9d53243544ca881'),
    value: '>'
  },
  {
    label: i18n.global.t('libs.enums.c2c00337338da28d49a746584125031a'),
    value: '<'
  },
  {
    label: i18n.global.t('libs.enums.9d4011491b8636a468c4ed367a0a628d'),
    value: '>='
  },
  {
    label: i18n.global.t('libs.enums.9b4e715c4b5e19537d6c8528a26fc962'),
    value: '<='
  },
  {
    label: i18n.global.t('libs.enums.72e5a3afb00477eb44f95f803d0c0018'),
    value: 'contains'
  },
  {
    label: i18n.global.t('libs.enums.911ccdf2cdcfe84a1c3782b7ed43bfda'),
    value: 'not contains'
  },
  {
    label: i18n.global.t('libs.enums.09582cab16d7ce5942573745172d133a'),
    value: 'null'
  },
  {
    label: i18n.global.t('libs.enums.e9d7aebb1e611a63213c479950723ade'),
    value: 'not null'
  },
  {
    label: i18n.global.t('libs.enums.1b017cc53bfb6c33394df8c750fcee72'),
    value: 'start with'
  },
  {
    label: i18n.global.t('libs.enums.aaec657d09f5890eb2215d1a483a6e6d'),
    value: 'end with'
  }
];
export const logicalOperators = [
  {
    label: 'or',
    value: 'or'
  },
  {
    label: 'and',
    value: 'and'
  }
];
export const pythonDefaultCode = `
def main(args1: int, args2: int) -> dict:
  return {
    "result": args1 + args2
}
`;
export const javascriptDefaultCode = `
function main({args1, args2}){
  return {
    result: args1 + args2
  }
}
`;
export const codeLangOptions = [
  {
    label: 'javascript',
    value: 'javascript'
  },
  {
    label: 'python',
    value: 'python3'
  }
];
export const outputsTypesOptions = [
  {
    label: 'String',
    value: 'string'
  },
  {
    label: 'Number',
    value: 'number'
  },
  {
    label: 'Array[Number]',
    value: 'array[number]'
  },
  {
    label: 'Array[String]',
    value: 'array[string]'
  },
  {
    label: 'Array[Object]',
    value: 'array[object]'
  },
  {
    label: 'Object',
    value: 'object'
  },
  {
    label: 'Any',
    value: 'any'
  },
  {
    label: 'Boolean',
    value: 'boolean'
  }
];
export const outputsTypesOptions2 = [
  {
    label: 'String',
    value: 'string'
  },
  {
    label: 'Integer',
    value: 'integer'
  },
  {
    label: 'Boolean',
    value: 'boolean'
  },
  {
    label: 'Float',
    value: 'float'
  },
  {
    label: 'Array',
    value: 'array'
  },
  {
    label: 'Object',
    value: 'object'
  }
];
export const outputsTypesOptions3 = [
  {
    label: i18n.global.t('libs.enums.53521cdc3a94b7eb5dde5648d42ea99c'),
    value: 'string'
  },
  {
    label: i18n.global.t('libs.enums.1a6183349dec1b9dc82794cf216d7ae3'),
    value: 'number'
  },
  {
    label: i18n.global.t('libs.enums.e4c25f4e78abe296c3515e894dc5c6ae'),
    value: 'array<number>'
  },
  {
    label: i18n.global.t('libs.enums.ca9e1b3cabe41897a6e5d416a65fdefb'),
    value: 'array<string>'
  },
  {
    label: i18n.global.t('libs.enums.b286bb35bd08df11723d05fe66ba9fe9'),
    value: 'array<object>'
  },
  {
    label: i18n.global.t('libs.enums.b4823cfb8818cff9f0d6c9794ea6d073'),
    value: 'array<boolean>'
  },
  {
    label: i18n.global.t('libs.enums.656199b47da5b7e3869f9320c0f14a3c'),
    value: 'object'
  },
  {
    label: i18n.global.t('libs.enums.86af234114a58b4fe36e199b197f7590'),
    value: 'boolean'
  }
];
export const argTypesOptions = [
  {
    label: 'String',
    value: 'string'
  },
  {
    label: 'Integer',
    value: 'integer'
  },
  {
    label: 'Float',
    value: 'float'
  },
  {
    label: 'Object',
    value: 'object'
  },
  {
    label: 'Array',
    value: 'array'
  },
  {
    label: 'Any',
    value: 'any'
  },
  {
    label: 'Boolean',
    value: 'boolean'
  }
];
export const publishTypeOptions = [
  {
    value: 0,
    label: i18n.global.t('libs.enums.3e5ff198195f2a8dc783e0e8deac581e')
  },
  {
    value: 1,
    label: i18n.global.t('libs.enums.c1031b3837b4265db61c26194a694796')
  },
  {
    value: 2,
    label: i18n.global.t('libs.enums.51eac875052e60afc04dcaeeef59992d')
  },
  {
    value: 3,
    label: i18n.global.t('libs.enums.293ed6a04ddf112f70b8faf540ac1fb4')
  }
];
export const chartTypeOptions = [
  {
    label: i18n.global.t('libs.enums.035efdca2ae0b1ca0609c0bb1816d39c'),
    value: 'bar'
  },
  {
    label: i18n.global.t('libs.enums.f78b566611eb6e8cc2b64187968c7a2b'),
    value: 'line'
  },
  {
    label: i18n.global.t('libs.enums.035f067b28e9f3a9e3777fd5b65fc09d'),
    value: 'pie'
  }
];
export const searchTypeOptions = {
  plain: i18n.global.t('libs.enums.2608196d71229af43a4c44a903885d71'),
  structured: i18n.global.t('libs.enums.0018fdadaf1b8b066f97445e6e93d859'),
  structured_tree: i18n.global.t('libs.enums.9d805da1239d91788d7c7a2911cccd31')
};
export const searchTypeIconMap = {
  plain: 'retrievalTest',
  structured: 'structuredRetrieval',
  structured_tree: 'tree-structure'
};
export const requiredOptions = [
  {
    label: i18n.global.t('libs.enums.2a14e3703de7f7a02cf75b6c33ef9723'),
    value: 1
  },
  {
    label: i18n.global.t('libs.enums.b05e1fbd9b05ae522a743347ebed4e89'),
    value: 0
  }
];
export const collectionTypeOptions = [
  {
    label: i18n.global.t('libs.enums.4312c6a64adfccc64d35addc797e9a04'),
    value: 1
  },
  {
    label: i18n.global.t('libs.enums.90bc5114fc1f1dfc0c5a6d4e86775065'),
    value: 2
  },
  {
    label: i18n.global.t('libs.enums.97960c18d118d73f7e7929dc74058a47'),
    value: 3
  }
];
export const parseConfirmationOptions = [
  {
    label: i18n.global.t('libs.enums.5d6414e81c151ab74bd4dcf031e0b4e9'),
    value: 1
  },
  {
    label: i18n.global.t('libs.enums.5059d02cc722c2d46fd03396d75c22ae'),
    value: 2
  }
];
export const chapterTypeOptions = [
  {
    label: i18n.global.t('libs.enums.7a8e101a49938f73dde4b102e6ddbe42'),
    value: '1'
  },
  {
    label: i18n.global.t('libs.enums.1cebe765fc43bf29272f6f0da4e7c9cb'),
    value: '2'
  }
];
export const userCodePrefix = 'agent';
export const colors = [
  '#FF702D',
  '#FFA616',
  '#72C938',
  '#25C987',
  '#1EC0E4',
  '#6AA3FF',
  '#2176FF',
  '#7A7AFF',
  '#BE5CF7',
  '#FF6969',
  '#F54141',
  '#BA3A01'
];
export const dataTableFieldTypeOptions = [
  {
    label: i18n.global.t(
      'views.database.components.EditConfigDialog.7eafe4716df0d4a1a57208598f121c76'
    ),
    value: 'text'
  },
  {
    label: i18n.global.t(
      'views.database.components.EditConfigDialog.19c80160200ad7d63bcbc83a9477e92f'
    ),
    value: 'longtext'
  },
  {
    label: i18n.global.t(
      'views.database.components.EditConfigDialog.8b0707d660311e36c64bdd71dda4ac1c'
    ),
    value: 'int'
  },
  {
    label: i18n.global.t(
      'views.database.components.EditConfigDialog.4e048037a88baa0bd9c3bb5a2c42ab52'
    ),
    value: 'float'
  },
  {
    label: i18n.global.t(
      'views.database.components.EditConfigDialog.0d03f8566df5aee5e910b77af1c97058'
    ),
    value: 'date'
  },
  {
    label: i18n.global.t(
      'views.database.components.EditConfigDialog.47b7d1d8cf6b8743092cbe5b84a19060'
    ),
    value: 'datetime'
  }
];
export const varTypeOptions = [
  {
    label: i18n.global.t('libs.enums.53521cdc3a94b7eb5dde5648d42ea99c'),
    value: 'string'
  },
  {
    label: i18n.global.t('libs.enums.1a6183349dec1b9dc82794cf216d7ae3'),
    value: 'number'
  },
  {
    label: i18n.global.t('libs.enums.86af234114a58b4fe36e199b197f7590'),
    value: 'boolean'
  },
  {
    label: i18n.global.t('libs.enums.075b36a3725726666b9265bb611d37de'),
    value: 'array',
    children: [
      {
        label: i18n.global.t('libs.enums.53521cdc3a94b7eb5dde5648d42ea99c'),
        value: 'string'
      },
      {
        label: i18n.global.t('libs.enums.1a6183349dec1b9dc82794cf216d7ae3'),
        value: 'number'
      },
      {
        label: i18n.global.t('libs.enums.86af234114a58b4fe36e199b197f7590'),
        value: 'boolean'
      },
      {
        label: i18n.global.t('libs.enums.656199b47da5b7e3869f9320c0f14a3c'),
        value: 'object'
      }
    ]
  },
  {
    label: i18n.global.t('libs.enums.656199b47da5b7e3869f9320c0f14a3c'),
    value: 'object'
  }
];
export const LanguageDetectStrategy = {
  FIRST_TURN: 1,
  PER_TURN_CURRENT: 2,
  PER_TURN_MULTI: 3,
  EXTERNAL_VOICE: 4
};
export const languageDetectStrategyOptions = [
  {
    label: i18n.global.t('libs.enums.535981f596578fa9ba0940f6a573b95c'),
    value: LanguageDetectStrategy.FIRST_TURN,
    tip: i18n.global.t('libs.enums.cd97ee61da8da822c07370225322e83f')
  },
  {
    label: i18n.global.t('libs.enums.c054e413cc41de14c329c219d8a548a2'),
    value: LanguageDetectStrategy.PER_TURN_CURRENT,
    tip: i18n.global.t('libs.enums.76c9da8e7f53689698a5773d66047a5c')
  },
  {
    label: i18n.global.t('libs.enums.6ee28ffaf883c0fe209ed434b0b1317b'),
    value: LanguageDetectStrategy.PER_TURN_MULTI,
    tip: i18n.global.t('libs.enums.fcf3a9daf607146ee22e10190e766b6b')
  },
  {
    label: i18n.global.t('libs.enums.a89f4da7aa8b7316a326386ef23d6ec5'),
    value: LanguageDetectStrategy.EXTERNAL_VOICE,
    tip: i18n.global.t('libs.enums.c2570b000376e1915f785217398272b8')
  }
];
